import React from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row } from 'react-bootstrap';
import { translate } from 'react-i18next';
import Layout from '../../components/layout/Layout';
import Card from '../../components/card/Card';
import Alert from '../../modal/alert/Alert';
import BuildingLibrary from '../../components/project_detail/BuildingLibrary';
import BuildingComponent from '../../components/project_detail/BuildingComponent';
import BuildingEditModal from '../../modal/buildings/BuildingEditModal';

import {
  EnergyEvaluationResult,
  EvaluationResultDetail,
  SystemEvaluationResult,
} from '../../components/evaluation/EvaluationResult';

import { defaultRejectHandler, getErrorValue } from '../../utils/utility';

import {
  exportReport,
  getBuilding,
  deleteBuilding,
  clearErrorBuilding,
} from '../../redux/buildings/buildings_actions';

import '../../components/default.css';
import ErrorModal from '../../modal/util/ErrorModal';
import LoadingModal from '../../modal/util/LoadingModal';

class BuildingDetailPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      buildingId: this.props.match.params.buildingId,
      isShowEditModal: false,
      isShowDeleteModal: false,
      isShowErrorModal: false,
      isEdited: false,
    };

    this.defaultStatus = 'unset';

    this.statusMapper = {
      unset: 'status-pending',
      failed: 'status-failed',
      passed: 'status-passed',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.deleting !== nextProps.deleting && !nextProps.deleting && !nextProps.building) {
      nextProps.history.push(`/projects/mixeduse/${this.props.building.project_id}`);
    }

    if (nextProps.isCalcExporting !== this.props.isCalcExporting && !nextProps.isCalcExporting && !nextProps.exportReportErrorMessage) {
      const link = document.createElement('a');
      link.href = nextProps.reportUrl;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    if(nextProps.exportReportErrorMessage !== this.props.exportReportErrorMessage && nextProps.exportReportErrorMessage){
      this.setState({ isShowErrorModal: true });
    }
    if (nextProps.isEditing !== this.props.isEditing && !nextProps.isEditing && !nextProps.exportReportErrorMessage) {
      this.setState({ isShowEditModal: false, isEdited: true })
    }
  }

  componentDidMount() {
    this.props.getBuilding(this.state.buildingId);
  }

  dismissErrorModal() {
    this.props.clearError();
    this.setState({ isShowErrorModal: false });
  }

  dismissEditModal() {
    this.props.clearError();
    this.setState({ isShowEditModal: false });
  }

  dismissDeleteModal() {
    this.props.clearError();
    this.setState({ isShowDeleteModal: false });
  }

  renderActionMenu() {
    const { t, building } = this.props;
    return [
      <li key="building-edit-menu">
        <a
          href="#"
          id="building-edit"
          onClick={() => this.setState({ isShowEditModal: true, isEdited: false })}
        >
          <i className="fas fa-edit" /><span className="menu-text">{t('edit building')}</span>
        </a>
      </li>,
      <li key="building-delete-menu">
        <a
          href="#"
          id="building-delete"
          onClick={() => this.setState({ isShowDeleteModal: true })}
        >
          <i className="fas fa-trash" /><span className="menu-text">{t('delete building')}</span>
        </a>
      </li>,
      <li key="building-export-report-menu">
        <a
          href="#"
          id="building-export-report"
          onClick={() => !this.props.isCalcExporting && this.props.exportReport(this.state.buildingId)}
        >
          <i className="fas fas fa-file-download" /><span className="menu-text">{t('report')}</span>
        </a>
      </li>,
    ].filter(element => {
      if (element.key === 'building-export-report-menu') {
        return false;
      }
      return element.key === 'building-delete-menu' ? building && building.is_deletable : true;
    });
  }

  renderEvaluationStatus(status) {
    const { t } = this.props;
    return (
      <span style={{ fontWeight: 'bold' }}>
        {t('overall')}:
        <span className={'building-status-text ' + this.statusMapper[status]}>
          {' ' + t(status.toLowerCase()).toUpperCase()}
        </span>
      </span>
    );
  }

  renderBuilding(building) {
    const { errorMessage, t } = this.props;
    const { evaluation } = building;
    const {
      evaluation_all_system,
      evaluation_energy_consumption,
    } = evaluation;

    return (
      <Grid>
        <LoadingModal
            show={this.props.isCalcExporting || this.props.isSummaryExporting}
        />
        <ErrorModal
          show={this.state.isShowErrorModal}
          errorMessage={this.props.exportReportErrorMessage}
          onHide={()=> this.dismissErrorModal()}
        />
        <BuildingEditModal
          building={building}
          show={this.state.isShowEditModal}
          isEdited={this.state.isEdited}
          onHide={() => this.dismissEditModal()}
        />
        <Alert
          show={this.state.isShowDeleteModal}
          onHide={() => !this.props.deleting && this.dismissDeleteModal()}
          title={t('delete building')}
          body={`${t('do you want to delete')} ${building.name}?`}
          errorMessage={getErrorValue(errorMessage, 'detail')}
          primaryButtonTitle={this.props.deleting ? t('deleting') : t('delete')}
          primaryButtonStyle="danger"
          primaryButtonEnabled={!this.props.deleting}
          onPrimaryButtonClick={() => this.props.deleteBuilding(building.id)}
        />
        <Row>
          <Col xs={12} sm={12} md={6}>
            <Card
              header={t('evaluation 1')}
              footer={this.renderEvaluationStatus(evaluation_all_system)}
            >
              <SystemEvaluationResult evaluation={evaluation} t={t} />
            </Card>
          </Col>
          <Col xs={12} sm={12} md={6}>
            <Card
              header={t('evaluation 2')}
              footer={this.renderEvaluationStatus(evaluation_energy_consumption)}
            >
              <EnergyEvaluationResult evaluation={evaluation} t={t} />
              <div style={{ height: '105px' }} />
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={12} md={12}>
            <Card header={t('evaluation detail')}>
              <EvaluationResultDetail evaluation={evaluation} t={t} />
            </Card>
          </Col>
        </Row>
        <Row className="show-grid">
          <Col xs={12}>
            <Card padding={false}>
              <BuildingLibrary building={building} />
            </Card>
          </Col>
        </Row>
        <Row className="show-grid">
          <Col xs={12}>
            <Card padding={false}>
              <BuildingComponent building={building} />
            </Card>
          </Col>
        </Row>
      </Grid>
    );
  }

  render() {
    const { building, t } = this.props;
    let breadcrumbItems = [];

    let body;
    if (this.props.isLoading) {
      body = <span>{t('loading')}</span>;
    } else if (building) {
      body = this.renderBuilding(building);
      breadcrumbItems = [
        {
          name: t('projects'),
          path: '/projects',
        },
        {
          name: `${building.project_name}`,
          path: `/projects/mixeduse/${building.project_id}`,
        },
        {
          name: `${building.name}`,
          path: '/id',
        },
      ];
    } else {
      body = <h4>{t('building not found')}</h4>;
    }

    const helpConfig = {
      title: t('help'),
      contentUrl: 'https://bec-uat.everyresearch.com/bec_help_evaluation.pdf',
    };

    return (
      <Layout
        history={this.props.history}
        breadcrumbItems={breadcrumbItems}
        renderActionMenu={() => this.renderActionMenu()}
        help={helpConfig}
      >
        {body}
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  loading: state.building.loading,
  deleting: state.building.deleting,
  building: state.building.objects[ownProps.match.params.buildingId],
  isCalcExporting: state.building.exporting,
  reportUrl: state.building.reportUrl,
  exportReportErrorMessage: state.building.errorMessage,
  isEditing: state.building.editing,
});

const mapDispatchToProps = dispatch => ({
  getBuilding: id => defaultRejectHandler(dispatch(getBuilding(id))),
  deleteBuilding: id => defaultRejectHandler(dispatch(deleteBuilding(id))),
  exportReport: id => defaultRejectHandler(dispatch(exportReport(id))),
  clearError: () => dispatch(clearErrorBuilding()),
});

export default translate('translations')(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(BuildingDetailPage),
);



// WEBPACK FOOTER //
// ./src/pages/buildings/BuildingDetailPage.js